$(document).ready(function(){

  fetch('/cart.js').then(response => response.json()).then(data => {
    console.log("data total price: "+data.total_price);
  });
  
  // homepage logo slide
  $('.brands-image-slide').slick({
    infinite: true,
    slidesToShow: 5,
    autoplay: true, /* this is the new line */
    slidesToScroll: 1,
    //  prevArrow:"<div class='pre-btn'><svg width='47' height='40' viewBox='0 0 47 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20.0169 1.23668C20.1106 1.33103 20.1849 1.44307 20.2355 1.56641C20.2862 1.68974 20.3123 1.82193 20.3123 1.95544C20.3123 2.08895 20.2862 2.22115 20.2355 2.34448C20.1849 2.46781 20.1106 2.57985 20.0169 2.6742L3.60874 19.226L45.489 19.226C45.7561 19.226 46.0123 19.3331 46.2012 19.5236C46.39 19.7141 46.4961 19.9725 46.4961 20.2419C46.4961 20.5114 46.39 20.7698 46.2012 20.9603C46.0123 21.1508 45.7561 21.2579 45.489 21.2579L3.60874 21.2579L20.0169 37.8097C20.1105 37.9041 20.1847 38.0161 20.2354 38.1394C20.286 38.2628 20.3121 38.395 20.3121 38.5284C20.3121 38.6619 20.286 38.7941 20.2354 38.9174C20.1847 39.0408 20.1105 39.1528 20.0169 39.2472C19.9234 39.3416 19.8123 39.4165 19.69 39.4675C19.5678 39.5186 19.4367 39.5449 19.3044 39.5449C19.1721 39.5449 19.041 39.5186 18.9188 39.4675C18.7965 39.4165 18.6855 39.3416 18.5919 39.2472L0.46407 20.9607C0.370433 20.8664 0.296151 20.7543 0.24547 20.631C0.194788 20.5076 0.168701 20.3754 0.168701 20.2419C0.168701 20.1084 0.194788 19.9762 0.24547 19.8529C0.296151 19.7296 0.370433 19.6175 0.46407 19.5232L18.5919 1.23668C18.6854 1.14222 18.7965 1.06729 18.9188 1.01617C19.041 0.965042 19.1721 0.938728 19.3044 0.938728C19.4368 0.938728 19.5678 0.965042 19.6901 1.01617C19.8123 1.06729 19.9234 1.14222 20.0169 1.23668Z' fill='black'/></svg></div>",
    // nextArrow:"<div class='next-btn'><svg width='47' height='40' viewBox='0 0 47 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M26.9828 1.23668C26.8892 1.33103 26.8149 1.44307 26.7642 1.56641C26.7135 1.68974 26.6875 1.82193 26.6875 1.95544C26.6875 2.08895 26.7135 2.22115 26.7642 2.34448C26.8149 2.46781 26.8892 2.57985 26.9828 2.6742L43.391 19.226L1.51073 19.226C1.24363 19.226 0.987465 19.3331 0.798599 19.5236C0.60973 19.7141 0.503624 19.9725 0.503624 20.2419C0.503624 20.5114 0.60973 20.7698 0.798599 20.9603C0.987465 21.1508 1.24363 21.2579 1.51073 21.2579L43.391 21.2579L26.9828 37.8097C26.8893 37.9041 26.815 38.0161 26.7644 38.1394C26.7138 38.2628 26.6877 38.395 26.6877 38.5284C26.6877 38.6619 26.7138 38.7941 26.7644 38.9174C26.815 39.0408 26.8893 39.1528 26.9828 39.2472C27.0764 39.3416 27.1875 39.4165 27.3097 39.4675C27.432 39.5186 27.563 39.5449 27.6953 39.5449C27.8277 39.5449 27.9587 39.5186 28.081 39.4675C28.2032 39.4165 28.3143 39.3416 28.4079 39.2472L46.5357 20.9607C46.6293 20.8664 46.7036 20.7543 46.7543 20.631C46.805 20.5076 46.8311 20.3754 46.8311 20.2419C46.8311 20.1084 46.805 19.9762 46.7543 19.8529C46.7036 19.7296 46.6293 19.6175 46.5357 19.5232L28.4079 1.23668C28.3143 1.14222 28.2033 1.06729 28.081 1.01617C27.9587 0.965042 27.8277 0.938728 27.6953 0.938728C27.563 0.938728 27.4319 0.965042 27.3097 1.01617C27.1874 1.06729 27.0764 1.14222 26.9828 1.23668Z' fill='black'/></svg></div>",
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  // homepage testimonial
  $('.testimonal-slider').slick({
    infinite: true,
    slidesToShow: 3,
    dots: true,
    slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='47' height='40' viewBox='0 0 47 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20.0169 1.23668C20.1106 1.33103 20.1849 1.44307 20.2355 1.56641C20.2862 1.68974 20.3123 1.82193 20.3123 1.95544C20.3123 2.08895 20.2862 2.22115 20.2355 2.34448C20.1849 2.46781 20.1106 2.57985 20.0169 2.6742L3.60874 19.226L45.489 19.226C45.7561 19.226 46.0123 19.3331 46.2012 19.5236C46.39 19.7141 46.4961 19.9725 46.4961 20.2419C46.4961 20.5114 46.39 20.7698 46.2012 20.9603C46.0123 21.1508 45.7561 21.2579 45.489 21.2579L3.60874 21.2579L20.0169 37.8097C20.1105 37.9041 20.1847 38.0161 20.2354 38.1394C20.286 38.2628 20.3121 38.395 20.3121 38.5284C20.3121 38.6619 20.286 38.7941 20.2354 38.9174C20.1847 39.0408 20.1105 39.1528 20.0169 39.2472C19.9234 39.3416 19.8123 39.4165 19.69 39.4675C19.5678 39.5186 19.4367 39.5449 19.3044 39.5449C19.1721 39.5449 19.041 39.5186 18.9188 39.4675C18.7965 39.4165 18.6855 39.3416 18.5919 39.2472L0.46407 20.9607C0.370433 20.8664 0.296151 20.7543 0.24547 20.631C0.194788 20.5076 0.168701 20.3754 0.168701 20.2419C0.168701 20.1084 0.194788 19.9762 0.24547 19.8529C0.296151 19.7296 0.370433 19.6175 0.46407 19.5232L18.5919 1.23668C18.6854 1.14222 18.7965 1.06729 18.9188 1.01617C19.041 0.965042 19.1721 0.938728 19.3044 0.938728C19.4368 0.938728 19.5678 0.965042 19.6901 1.01617C19.8123 1.06729 19.9234 1.14222 20.0169 1.23668Z' fill='black'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='47' height='40' viewBox='0 0 47 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M26.9828 1.23668C26.8892 1.33103 26.8149 1.44307 26.7642 1.56641C26.7135 1.68974 26.6875 1.82193 26.6875 1.95544C26.6875 2.08895 26.7135 2.22115 26.7642 2.34448C26.8149 2.46781 26.8892 2.57985 26.9828 2.6742L43.391 19.226L1.51073 19.226C1.24363 19.226 0.987465 19.3331 0.798599 19.5236C0.60973 19.7141 0.503624 19.9725 0.503624 20.2419C0.503624 20.5114 0.60973 20.7698 0.798599 20.9603C0.987465 21.1508 1.24363 21.2579 1.51073 21.2579L43.391 21.2579L26.9828 37.8097C26.8893 37.9041 26.815 38.0161 26.7644 38.1394C26.7138 38.2628 26.6877 38.395 26.6877 38.5284C26.6877 38.6619 26.7138 38.7941 26.7644 38.9174C26.815 39.0408 26.8893 39.1528 26.9828 39.2472C27.0764 39.3416 27.1875 39.4165 27.3097 39.4675C27.432 39.5186 27.563 39.5449 27.6953 39.5449C27.8277 39.5449 27.9587 39.5186 28.081 39.4675C28.2032 39.4165 28.3143 39.3416 28.4079 39.2472L46.5357 20.9607C46.6293 20.8664 46.7036 20.7543 46.7543 20.631C46.805 20.5076 46.8311 20.3754 46.8311 20.2419C46.8311 20.1084 46.805 19.9762 46.7543 19.8529C46.7036 19.7296 46.6293 19.6175 46.5357 19.5232L28.4079 1.23668C28.3143 1.14222 28.2033 1.06729 28.081 1.01617C27.9587 0.965042 27.8277 0.938728 27.6953 0.938728C27.563 0.938728 27.4319 0.965042 27.3097 1.01617C27.1874 1.06729 27.0764 1.14222 26.9828 1.23668Z' fill='black'/></svg></div>",
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
       
  // product page tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
   active = links.first().addClass('active');
   content = $(active.attr('href'));
   links.not(':first').each(function () {
     $($(this).attr('href')).hide();
   });
 
    $(this).find('a').click(function(e){
      active.removeClass('active');
      active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
    
    $(this).find('.reviews').click(function(e){
      $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
    });
    
  });
     
  $('a.reviews').click(function(){
    $('.jdgm-widget.jdgm-review-widget.jdgm--done-setup-widget').show();
  });
  
    $('a.description.active').click(function(){
      $('.jdgm-widget.jdgm-review-widget.jdgm--done-setup-widget').hide();
    });
  
  // product page slider
  $('.slider-for').slick({
    prevArrow: "<div class='product pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
    nextArrow: "<div class='product next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",  
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: false,
    asNavFor: '.slider_thum'
  });
 
  $(".slider_thum").slick({
    // prevArrow: "<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
    // nextArrow: "<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",                  
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    vertical: true,
    asNavFor: '.slider-for',
    focusOnSelect: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          slidesToShow: 3
        }
      }
    ]
  });
  
  // product page slider image change swtach
  $('input.custom_swatch').click(function(){
    setTimeout(function() { 
      var current_url = window.location.href;
      var current_url_split = current_url.split('?')[1];
      var current_url_split_new = current_url_split.split('=')[1];
      
      $('.colors_variants').each(function(){
        var variants_id = $(this).attr('variants-id');
        if(current_url_split_new == variants_id) {
          var selected_image = $(this).attr('varinat-image');
          var selected_image_new = selected_image.split('/')[6];
          var selected_image_new1 = selected_image_new.split('?')[0];
          
          $('.custon_images_variants').each(function(){
            var variants_slider_img = $(this).attr('src');
            if(variants_slider_img.includes(selected_image_new1)){
              console.log('variants_slider_img11111');
              $(this).trigger('click');
            }
          });
        }
      });
    }, 500);
  }); 
    
  // product page swtach value selcted size
  $('input.custom_swatch.size').click(function(){
    var selected_val = $(this).attr('value');
    $(this).parents('.size').find('.form__label').html('Size: '+ selected_val);
    $(this).next('.custom-swatch_var').toggleClass('active');
    $('input.custom_swatch.size').not(this).next('.custom-swatch_var').removeClass('active');
  });
  
  // product page swtach value selcted color
  $('input.custom_swatch.color').click(function(){
    var selected_val = $(this).attr('value');
    $(this).parents('.color').find('.form__label').html('Color: '+ selected_val);
    $(this).next('.custom-swatch_var').toggleClass('active');
    $('input.custom_swatch.color').not(this).next('.custom-swatch_var').removeClass('active');
  });
  
  $('fieldset.js.product-form__input.color').find('.custom_swatch').eq(0).trigger("click");
  $('fieldset.js.product-form__input.size').find('.custom_swatch').eq(0).trigger("click");
  
  /* Homepage popup Close */
  $(".close.home").click(function() {
    $(".popup-home").fadeOut(500);
  });
});

$(document).on("click", "ul#categories-cls li.nav--has-dropdown span.arrow", function () {
  $(this).parent("li").hasClass("liactive") == !1
    ? ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"),
      $(this).addClass("active").siblings("ul").slideDown().parent("li").addClass("liactive"),
      $(this).html("<svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.042 10.0253C13.1753 10.0272 13.3039 10.054 13.4279 10.1058C13.5525 10.1575 13.6559 10.2256 13.738 10.3101L18.2727 14.9746C18.4534 15.1605 18.5417 15.3951 18.5377 15.6784C18.5337 15.9617 18.4388 16.1937 18.2529 16.3745C18.067 16.5552 17.8324 16.6436 17.5491 16.6396C17.2658 16.6356 17.0338 16.5406 16.853 16.3547L13.0085 12.4001L9.05381 16.2446C8.86791 16.4254 8.6333 16.5137 8.35 16.5097C8.06669 16.5057 7.83468 16.4108 7.65395 16.2249C7.47322 16.039 7.38486 15.8044 7.38885 15.5211C7.39285 15.2378 7.4878 15.0057 7.67371 14.825L12.3382 10.2904C12.4396 10.1918 12.5489 10.1227 12.6661 10.083C12.7834 10.0426 12.9087 10.0234 13.042 10.0253Z' fill='black'></path></svg>"))
    : ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"), $(this).html("<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 14.975C11.8667 14.975 11.7377 14.95 11.613 14.9C11.4877 14.85 11.3833 14.7833 11.3 14.7L6.69999 10.1C6.51665 9.91667 6.42499 9.68334 6.42499 9.4C6.42499 9.11667 6.51665 8.88334 6.69999 8.7C6.88332 8.51667 7.11665 8.425 7.39999 8.425C7.68332 8.425 7.91665 8.51667 8.09999 8.7L12 12.6L15.9 8.7C16.0833 8.51667 16.3167 8.425 16.6 8.425C16.8833 8.425 17.1167 8.51667 17.3 8.7C17.4833 8.88334 17.575 9.11667 17.575 9.4C17.575 9.68334 17.4833 9.91667 17.3 10.1L12.7 14.7C12.6 14.8 12.4917 14.8707 12.375 14.912C12.2583 14.954 12.1333 14.975 12 14.975Z' fill='black'></path></svg>"));
});

$(window).on('load', function () { 
  /* Homepage popup open */
  setTimeout(function () {
    $(".popup-home").fadeIn(500);
    var class_exits = $('.popup-home').find('.newsletter-form__message--success');
    if($(class_exits)[0]){
      $('.popup-home').hide();
    } else {
      var popupshow = localStorage.getItem('popupshow');
      if (popupshow== null) {
        localStorage.setItem('popupshow', 1);
        $('.popup-home').show();
      } else{
        $('.popup-home').hide();
      }
    }
  }, 1500);
});